module.exports = __webpack_public_path__ + "static/media/Frame 2826.7284eac3.jpg";